<template>

  <div v-show="isActive"><slot></slot></div>

</template>

<script>
export default {
  props: {
    name: {type: String, required: true},
  },
  data() {
    return {
      editing: false,
      isActive: false,
      dropdownOpen: false
    }
  },
  watch: {},
  computed: {},
  methods: {},
  mounted() {
    this.isActive = this.selected;
  }
}
</script>
